<template>
  <roe-plan-design-edit-form
    :designs="designs"
    name="Age Requirement"
    :view-input="ageRequirement"
    :form="$v.editableDesign"
  >
    <div class="right-panel-form-row-wrap">
      <div class="right-panel-label-wrap">
        <div class="light-label">
          Does the plan have an age requirement for Employee Contributions?
        </div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit">
          <roe-age-requirement-select :design="$v.editableDesign">
          </roe-age-requirement-select>
        </div>
      </div>
    </div>
    <template v-if="showAgeRequirements(editableDesign)">
      <div class="right-panel-form-row-wrap">
        <div class="right-panel-label-wrap">
          <div class="light-label">Age Requirement for the plan</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-age-requirement-years-input :design="$v.editableDesign">
            </roe-age-requirement-years-input>
          </div>
          <div class="form-unit">
            <roe-age-requirement-months-input :design="$v.editableDesign">
            </roe-age-requirement-months-input>
          </div>
        </div>
      </div>

      <div class="right-panel-form-row-wrap">
        <div class="right-panel-label-wrap">
          <div class="light-label">
            Apply to the Employer Contribution Match
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-age-requirement-sync-radio :design="$v.editableDesign">
            </roe-age-requirement-sync-radio>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:survey>
      <roe-survey-bar
        label="None"
        :percent="survey.age_requirement.none"
      ></roe-survey-bar>
      <roe-survey-bar
        label="18 or less"
        :percent="survey.age_requirement.age18"
      ></roe-survey-bar>
      <roe-survey-bar
        label="18 - 19"
        :percent="survey.age_requirement.age19"
      ></roe-survey-bar>
      <roe-survey-bar
        label="19 - 20"
        :percent="survey.age_requirement.age20"
      ></roe-survey-bar>
      <roe-survey-bar
        label="20 - 21"
        :percent="survey.age_requirement.age21"
      ></roe-survey-bar>
    </template>
  </roe-plan-design-edit-form>
</template>

<script>
import RoePlanDesignEditForm from "@/components/alternative-designs/_shared/EditForm";
import RoeSurveyBar from "@/components/charts/SurveyBar";
import { mapGetters } from "vuex";
import AgeRequirementsMixin from "@/components/_shared/inputs/design/_mixins/AgeRequirementsMixin";
import {
  RoeAgeRequirementSelect,
  RoeAgeRequirementYearsInput,
  RoeAgeRequirementMonthsInput,
  RoeAgeRequirementSyncRadio
} from "@/components/_shared/inputs/design/employee-contributions";

export default {
  name: "RoeAgeRequirement",
  components: {
    RoeAgeRequirementSyncRadio,
    RoeAgeRequirementSelect,
    RoeAgeRequirementYearsInput,
    RoeAgeRequirementMonthsInput,
    RoeSurveyBar,
    RoePlanDesignEditForm
  },
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  mixins: [AgeRequirementsMixin],
  validations() {
    return {
      editableDesign: this.ageRequirementValidations(this.editableDesign)
    };
  },
  computed: {
    ...mapGetters(["editableDesign", "ageRequirement", "survey"])
  }
};
</script>
